"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(weightStonesValue, weightPoundsValue) {
  // convert imperial weight to pounds
  var weightTotalPounds = parseInt(weightStonesValue, 10) * 14 + parseInt(weightPoundsValue, 10); // convert pounds to kilograms

  return (weightTotalPounds * 0.453592).toFixed(2);
};

exports["default"] = _default;